import { render, staticRenderFns } from "./PartInputBasic.vue?vue&type=template&id=63afbe06&scoped=true&"
import script from "./PartInputBasic.vue?vue&type=script&lang=js&"
export * from "./PartInputBasic.vue?vue&type=script&lang=js&"
import style0 from "./PartInputBasic.vue?vue&type=style&index=0&id=63afbe06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63afbe06",
  null
  
)

export default component.exports